import "../App.css";

export default function Firefly({
  size,
  drift1,
  drift2,
  left,
  animationDuration,
  animationDelay,
  blur,
}) {
  const style = {
    "--size": `${size}px`,
    "--drift-1": `${drift1}vw`,
    "--drift-2": `${drift2}vw`,
    "--blur": `${blur}px`,
    left: `${left}vw`,
    animationDuration: `${animationDuration}s, ${(animationDuration * 0.4).toFixed(1)}s`,
    animationDelay: `-${animationDelay}s, -${animationDelay}s`,
  };

  return <div className="firefly" style={style}></div>;
}
